import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiPost, operationsClient } from '@/lib/api';
import { opsEstimateEndpoints } from '@/lib/api/endpoints';
import { estimateKeys, jobKeys } from '@/lib/queryKeys';
import type { Estimate, EstimateFulfillmentMode } from '@/types/estimate';

type FulfillmentTarget = Exclude<EstimateFulfillmentMode, 'UNDECIDED'>;

export function useFulfillEstimate() {
  const queryClient = useQueryClient();

  return useApiMutation<Estimate, { id: string; fulfillmentMode: FulfillmentTarget }>({
    mutationFn: ({ id, fulfillmentMode }) =>
      apiPost<Estimate>(operationsClient, opsEstimateEndpoints.fulfill(id), {
        fulfillmentMode,
      }),
    onSuccess: (data) => {
      void queryClient.invalidateQueries({ queryKey: estimateKeys.lists() });
      void queryClient.invalidateQueries({ queryKey: estimateKeys.detail(data.id) });
      void queryClient.invalidateQueries({ queryKey: jobKeys.all() });
      // A follow-up Job the backend did NOT create is not an outcome to
      // announce here: the caller hands the operator the New Job form (or, on
      // an auto-convert tenant, reports the deposit queue) via
      // useFollowUpJobHandoff.
      if (data.fulfillmentMode === 'CURRENT_JOB') {
        toast.success('Approved work added to the current Job');
      } else if (data.jobId) {
        toast.success('Follow-up Job created');
      }
    },
  });
}
